import {post} from "./request";

export const statsApi = {};
statsApi.getStats = async (body) => {
  try {
    const {data} = await post(`/stats/getTechnicianStats`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
